<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <table class="c-indicator c-indicator-w-100">
      <thead>
        <tr>
          <th class="tab-wid-80">№<br /></th>
          <th class="tab-m-wid-100" style="width: 90%">
            Наименование промышленного оборудования
          </th>
          <th class="tab-wid-80"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in $parent.project.EQUIPMENT_INDUSTRIAL.items">
          <td class="tab-wid-80">{{ index + 1 }}</td>
          <td class="tab-wid-80">{{ item.UF_NAME }}</td>
          <td
            v-if="
              !$parent.$parent.projectDisabled &&
                !$parent.project.UF_IS_BLOCK &&
                $parent.project.UF_SETTING.IS_EQUIPMENT_ACCEPT !== 1 &&
                !isPurchasedListCoordinated
            "
          >
            <i class="i-edit centerIcon" @click="editItem(index)"></i>
            <i
              class="i-delete centerIcon"
              title="Удалить запись"
              @click="deleteItem(index, item)"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <div
      class="add-row"
      v-show="
        !$parent.$parent.projectDisabled &&
          !$parent.project.UF_IS_BLOCK &&
          $parent.project.UF_SETTING.IS_EQUIPMENT_ACCEPT !== 1 &&
          !isPurchasedListCoordinated
      "
    >
      <a class="link-add-row" @click="showAddItem">Добавить</a>
    </div>
    <div
      class="modal fade in"
      v-bind:class="{ show: showForm }"
      tabindex="-1"
      role="dialog"
    >
      <form v-on:submit.prevent="submit">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                @click="showForm = false"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">
                {{ Object.keys(item).length > 0 ? "Изменить" : "Добавить" }}
                позицию
              </h4>
            </div>
            <div class="modal-body">
              <div
                class="form-group"
                v-bind:class="{ 'has-error': checkError('UF_NAME') }"
              >
                <label>Наименование<span class="red">*</span></label>
                <textarea
                  type="text"
                  class="form-control"
                  v-model="item.UF_NAME"
                  rows="3"
                  maxlength="1000"
                />
                <span class="frp-input-description"
                  >Доступно для ввода символов:
                  {{ countEntChar(item.UF_NAME, 1000) }}
                </span>
              </div>
              <button type="button" @click="submit" class="btn btn-info">
                Сохранить
              </button>
              <button
                type="button"
                @click="showForm = false"
                class="btn btn-default btn-style-big"
              >
                Отмена
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ProjectsService } from "@/common/api.service";

export default {
  name: "EquipmentIndustrial",
  data() {
    return {
      showForm: false,
      editIndex: -1,
      item: {},
      errorFields: {},
      nameEquipment: "ProjectInductrialEquipmentModel"
    };
  },
  computed: {
    isPurchasedListCoordinated() {
      const list =
        this.$parent && this.$parent.project && this.$parent.project.COORDINATIONS;
      if (!Array.isArray(list)) {
        return false;
      }
      return list.some(
        el =>
          el &&
          (el.UF_TYPE_PAGE === "list_of_purhased_10_01") &&
          (el.UF_IS_COORDINATION == 1 || el.UF_IS_COORDINATION === true)
      );
    }
  },
  methods: {
    showAddItem() {
      this.setError("");
      this.showForm = true;
      this.editIndex = -1;
      this.item = {};
      this.item.UF_SORT_NUMBER = (this.$parent.project.EQUIPMENT_INDUSTRIAL.items.length + 1);
    },
    editItem(index) {
      this.setError("");
      this.editIndex = index;
      this.item = JSON.parse(
        JSON.stringify(this.$parent.project.EQUIPMENT_INDUSTRIAL.items[index])
      );
      this.showForm = true;
    },
    deleteItem(index, item) {
      this.item = item;
      if (confirm("Вы уверены, что хотите удалить запись?")) {
        this.deleteItemAction(index, item);
      }
    },
    deleteItemAction(index){
      ProjectsService.deleteEqipmentProject(this.$parent.project.ID, this.nameEquipment, this.item.ID).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 10000
            });
          }, this);
        } else {
          this.$toasted.show("Запись успешно удалена", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });

          this.$parent.project.EQUIPMENT_INDUSTRIAL.items.splice(index, 1);

          this.$parent.project.EQUIPMENT_INDUSTRIAL.items.forEach(function(itemTemp, index2) {
            if (index2 >= index) {
              this.$parent.project.EQUIPMENT_INDUSTRIAL.items[index2].UF_SORT_NUMBER= parseInt(itemTemp.UF_SORT_NUMBER) - 1;
            }
          }, this);

        }
      }, this).catch(error => {
        this.handleModuleBlocked(error);
      });
    },
    handleModuleBlocked(error) {
      const status = (error && error.response && error.response.status) || 0;
      const messageHas403 = error && error.message && error.message.indexOf("403") !== -1;
      if (status === 403 || messageHas403) {
        this.$toasted.show("Модуль заблокирован Сотрудником ДМКП", {
          theme: "red",
          position: "bottom-right",
          duration: 10000
        });
      }
    },
    submit() {
      this.setError("");
      if (!this.item.UF_NAME) {
        this.setError("UF_NAME");
      }
      if (Object.keys(this.errorFields).length) {
        return;
      }

      if (this.editIndex > -1) {
        ProjectsService.saveEqipmentProject(this.$parent.project.ID, this.nameEquipment, this.item.ID, this.item).then(({ data }) => {
          if (data.error) {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          } else {
            this.$toasted.show("Запись успешно изменена", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });

            this.$parent.project.EQUIPMENT_INDUSTRIAL.items[
              this.editIndex
              ] = JSON.parse(JSON.stringify(this.item));

            this.showForm = false;
          }
        }, this).catch(error => {
          this.handleModuleBlocked(error);
        });
      } else {
        ProjectsService.addEqipmentProject(this.$parent.project.ID, this.nameEquipment, this.item).then(({ data }) => {
          if (data.error) {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 10000
              });
            }, this);
          } else {
            this.$toasted.show("Запись успешно добавлена", {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            });
            this.item.ID = data.ID;
            this.$parent.project.EQUIPMENT_INDUSTRIAL.items.push(this.item);
            this.showForm = false;
          }
        }, this).catch(error => {
          this.handleModuleBlocked(error);
        });
      }
      return false;
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    setError(field, val) {
      if (!field) {
        this.errorFields = {};
        return;
      }
      this.errorFields[field] = val ? val : true;
    },
    checkError(field) {
      if (this.errorFields[field]) {
        return true;
      }
      return false;
    },
    countEntChar(value, limit) {
      if (value) {
        const length = String(value).length;
        return length > limit ? 0 : limit - length;
      }
      return limit;
    }
  }
};
</script>

<style scoped></style>
